import { useEffect } from "react";

const DonutChart = ({ data, size = 240, onColorData }) => {
  const React = require("react");
  const radius = size / 2;
  const innerRadius = radius * 0.6; // 60% of outer radius for donut effect
  const center = radius;

  // Generate colors for each slice
  const colors = [
    "#DE350B",
    "#0052CC",
    "#C20097",
    "#00A3BF",
    "#FFEAA7",
    "#5243AA",
    "#79AD0B",
    "#FACC00",
  ];

  // Calculate cumulative percentages for positioning
  let cumulativePercentage = 0;
  const slices = data.map((item, index) => {
    const startAngle = (cumulativePercentage / 100) * 360;
    const endAngle = ((cumulativePercentage + item.drugPercentage) / 100) * 360;
    cumulativePercentage += item.drugPercentage;

    return {
      ...item,
      startAngle,
      endAngle,
      color: colors[index % colors.length],
    };
  });

  // Pass color data to parent component if callback is provided
  useEffect(() => {
    if (onColorData && data.length > 0) {
      const colorData = data.map((item, index) => ({
        drugName: item.drugName,
        color: colors[index % colors.length],
      }));
      onColorData(colorData);
    }
  }, [data, onColorData]);

  // Convert angle to radians
  const toRadians = (angle) => (angle * Math.PI) / 180;

  // Create SVG path for donut slice
  const createSlicePath = (startAngle, endAngle) => {
    const startAngleRad = toRadians(startAngle - 90); // -90 to start from top
    const endAngleRad = toRadians(endAngle - 90);

    const x1 = center + radius * Math.cos(startAngleRad);
    const y1 = center + radius * Math.sin(startAngleRad);
    const x2 = center + radius * Math.cos(endAngleRad);
    const y2 = center + radius * Math.sin(endAngleRad);

    const x3 = center + innerRadius * Math.cos(endAngleRad);
    const y3 = center + innerRadius * Math.sin(endAngleRad);
    const x4 = center + innerRadius * Math.cos(startAngleRad);
    const y4 = center + innerRadius * Math.sin(startAngleRad);

    const largeArcFlag = endAngle - startAngle > 180 ? 1 : 0;

    return `
        M ${x1} ${y1}
        A ${radius} ${radius} 0 ${largeArcFlag} 1 ${x2} ${y2}
        L ${x3} ${y3}
        A ${innerRadius} ${innerRadius} 0 ${largeArcFlag} 0 ${x4} ${y4}
        Z
      `;
  };

  return (
    <div className="relative">
      <svg width={size} height={size} className="rotate-0 transform">
        {slices.map((slice, index) => (
          <g key={index}>
            <path
              d={createSlicePath(slice.startAngle, slice.endAngle)}
              fill={slice.color}
              stroke="white"
              strokeWidth="2"
              className="cursor-pointer transition-opacity hover:opacity-80"
            />
          </g>
        ))}
      </svg>

      {/* Center content */}
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="text-center">
          <div className="text-2xl font-bold text-gray-700">
            {data.reduce((sum, item) => sum + item.drugCount, 0)}
          </div>
          <div className="text-sm text-gray-500">Total Count</div>
        </div>
      </div>
    </div>
  );
};

export default DonutChart;
